<script>
    import { Route, navigateTo } from 'svelte-router-spa';


    export let currentRoute;

    let stage = {
        status: 'clean-complete',
        account: {
            id: 56372099010,
            username: 'photographer.london',
            avatar: '/img/photographer-avatar.jpg',
            followers: 10849,
            follows: 355,
        },
        analyzeStats: {
            scanProgress: 0,
            followingsScanned: 0,
            followersScanned: 0,
            botsFound: 0,
            commercialsFound: 0,
            nonReciprocalFound: 0,
            inactiveFound: 0,
            foreignersFound: 0,
            unattainableFound: 0,
            timeLeft: 10000,
        },
        cleanupStats: {
            cleanProgress: 100,
            threadsRemoved: 1597,
            finishedAt: (new Date()),
            followsBots: 6,
            followsCommercial: 90,
            followsNonreciprocal: 278,
            followsInactive: 255,
            followsForeigners: 13,
            followsUnattainable: 0,
            followersBots: 492,
            followersCommercial: 201,
            followersNonreciprocal: 0,
            followersInactive: 323,
            followersForeigners: 26,
            followersUnattainable: 327,
        },
        whitelist: [
            {id: 35382744791, username: "hi_manshu6166", avatar: "/cache_avatars_4/353827/35382744791.jpg"},
            {id: 47525983162, username: "zarai.miriam", avatar: "/cache_avatars_4/475259/47525983162.jpg"},
            {id: 45491864973, username: "soufiane_hk7", avatar: "/cache_avatars_4/454918/45491864973.jpg"},
            {id: 47157471416, username: "mary.em3674", avatar: "/cache_avatars_4/471574/47157471416.jpg"},
            {id: 46761947400, username: "kish.an8285", avatar: "/cache_avatars_4/467619/46761947400.jpg"},
            {id: 46723388215, username: "vinith8134", avatar: "/cache_avatars_4/467233/46723388215.jpg"},
            {id: 47398354831, username: "sunilverma9729825909", avatar: "/cache_avatars_4/473983/47398354831.jpg"},
            {id: 47544847010, username: "brex.francisco", avatar: "/cache_avatars_4/475448/47544847010.jpg"},
            {id: 47546782118, username: "alfinterrico", avatar: "/cache_avatars_4/475467/47546782118.jpg"},
            {id: 46710177225, username: "sali.ma3793", avatar: "/cache_avatars_4/467101/46710177225.jpg"},
            {id: 3932740210, username: "coachajmadden", avatar: "/cache_avatars_4/393274/3932740210.jpg"},
            {id: 10595106444, username: "lightningbuggiftco", avatar: "/cache_avatars_4/105951/10595106444.jpg"},
            {id: 4704342064, username: "alinepereirapoatinha", avatar: "/cache_avatars_4/470434/4704342064.jpg"},
            {id: 203486917, username: "laurenhendon", avatar: "/cache_avatars_4/203486/203486917.jpg"},
            {id: 3981654597, username: "melissatheaxe", avatar: "/cache_avatars_4/398165/3981654597.jpg"},
            {id: 1611178470, username: "mari2s2a", avatar: "/cache_avatars_4/161117/1611178470.jpg"},
            {id: 474347724, username: "marcel_ferreira_att", avatar: "/cache_avatars_4/474347/474347724.jpg"},
            {id: 17711499670, username: "rozinkinaekaterina", avatar: "/cache_avatars_4/177114/17711499670.jpg"},
            {id: 2886689135, username: "lenochkaepikhina", avatar: "/cache_avatars_4/288668/2886689135.jpg"},
            {id: 12138342074, username: "rybina124", avatar: "/cache_avatars_4/121383/12138342074.jpg"},
            {id: 7287862344, username: "biscuiter_", avatar: "/cache_avatars_4/728786/7287862344.jpg"},
        ],
        guard: {
            isActive: true,
            filterSubscribers: true,
            filterComments: true,
            filterSpamMarks: true,
            filterDirectRequests: true,
            createBackup: true,
        },
    };

    if (window.localStorage.getItem('stage')) {
        stage = JSON.parse(window.localStorage.getItem('stage'));
    }

    function setStage(newParams) {
        let newStage = stage;
        for (let key in newParams) {
            if (typeof newParams[key] === 'object') {
                for (let subKey in newParams[key]) {
                    newStage[key][subKey] = newParams[key][subKey];
                }
            } else {
                newStage[key] = newParams[key];
            }
        }

        stage = newStage;
        window.localStorage.setItem('stage', JSON.stringify(stage));
    }

    function changeRoute(newRoute, params = {}) {
        navigateTo(newRoute, params);
    }

    const params = {
        stage: stage,
        setStage: setStage,
    }

    function routeLoaded(event) {
        console.log(event);
    }

</script>

<div class="layout-wrap">

    <div class="router-wrap">
        <section class="section">
            <Route {currentRoute}  params={params} on:routeLoaded={routeLoaded} />
        </section>
    </div>

</div>

<style>
    .banner-top {
        padding-top: 54px;
        background-size: cover;
        background-image: url('/static/media/baner.be7e8fe4.png');
        background-position: bottom;
        width: 100%;
        height: 400px;
    }

</style>